import { render, staticRenderFns } from "./OaoButton.vue?vue&type=template&id=529aa633&scoped=true"
import script from "./OaoButton.vue?vue&type=script&lang=js"
export * from "./OaoButton.vue?vue&type=script&lang=js"
import style0 from "./OaoButton.vue?vue&type=style&index=0&id=529aa633&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0d1d51ab4c56f75a7402f3cb98fb63e0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529aa633",
  null
  
)

export default component.exports